import { isCapabilityEnabled } from "owa-capabilities";
import type { Capability } from "owa-capabilities";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { addinsResizablePaneCapability } from "./addinsResizablePaneCapability";
import { addinsUseDrawerPaneInCalendarCapability } from "./addinsUseDrawerPaneInCalendarCapability";
import { addinsUseDrawerPaneInpopoutsCapability } from "./addinsUseDrawerPaneInpopoutsCapability";
import { newHeaderCapability } from "./newHeaderCapability";

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * Gates whether the add-in drawer pane is anchored under the ribbon inside the host
 * content (mail reading pane or calendar event form) instead of overlaying the whole
 * window. Only supported when the add-in drawer pane can be resized.
 */
export const addinsDrawerPaneUnderRibbonCapability: Capability = {
    isEnabled: () => {
        return true;
    },
    isSupported: () => {
        return (isGlobalFeatureEnabled("addin-drawerPaneUnderRibbon") &&
            isCapabilityEnabled(addinsUseDrawerPaneInCalendarCapability) &&
            isCapabilityEnabled(addinsResizablePaneCapability) &&
            isCapabilityEnabled(addinsUseDrawerPaneInpopoutsCapability) &&
            isCapabilityEnabled(newHeaderCapability));
    },
};
